var React = require('react');

function Hyperlink (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"20","cy":"20","r":"20","fill":"black","key":0}),React.createElement("path",{"d":"M24.6021 19.529L26.7033 15.8896C27.6527 14.2451 27.0893 12.1423 25.4448 11.1929C23.8003 10.2434 21.6975 10.8069 20.748 12.4514L17.3098 18.4066C16.3603 20.0511 16.9238 22.1539 18.5683 23.1034","stroke":"white","strokeWidth":"2","key":1}),React.createElement("path",{"d":"M15.3998 22.1357L13.2987 25.775C12.3492 27.4195 12.9127 29.5223 14.5572 30.4718C16.2016 31.4212 18.3045 30.8578 19.2539 29.2133L22.6922 23.258C23.6416 21.6136 23.0782 19.5107 21.4337 18.5613","stroke":"white","strokeWidth":"2","key":2}),React.createElement("defs",{"key":3})]);
}

Hyperlink.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = Hyperlink;

Hyperlink.default = Hyperlink;
